import { CloseIcon } from 'components/icons/CloseIcon';
import { ModalContext } from 'context/ModalContext';
import { useContext, useState } from 'react';
import api from 'services/api';

interface IExternalPoll {
  onCancel: () => void;
  videoId: string;
  setPollData: any;
}

export default function ExternalPoll({ onCancel, videoId, setPollData }: IExternalPoll) {
  const { hideModal } = useContext(ModalContext);
  const initialFormData = {
    external_poll: '',
    title: ''
  };
  const [formData, setFormData] = useState(initialFormData);

  const handleInputChange = (e: any) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value
    }));
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    api.post(`api/videos/${videoId}/polls/`, formData).then((res) => {
      setPollData((prev: any[]) => {
        const newPollData = prev.push(res.data);
        return newPollData;
      });
      onCancel();
    });
  };

  return (
    <div className="transparent font-lato">
      <form onSubmit={handleSubmit}>
        <div className="relative border-x border-t bg-gray-bg-dark border-gray-300  bg-white pt-9 px-7 w-screen md:w-[500px] md:min-h-[300px] rounded-t-lg">
          <div className="flex">
            <span className="font-bold text-2xl leading-6 text-[#1A1C1D]">Link to External Poll</span>
            <CloseIcon className="ml-auto w-5 h-5 cursor-pointer opacity-70 hover:opacity-100" onClick={onCancel} />
          </div>
          <div className="flex">
            <div className="flex-1">
              <p className="mb-1 font-bold mt-4">Survey Link</p>
              <input
                type="url"
                id="external_poll"
                name="external_poll"
                className="px-4 py-2 w-full mb-4 text-xl text-[#495057] border border-solid focus:text-[#495057] focus:border-[#80bdff] focus:outline-0 focus:shadow-form border-[#ced4da] rounded-md transition-shadow duration-150 ease-in-out leading-6"
                onChange={handleInputChange}
              />
              <p className="mb-1 font-bold">Name of the poll</p>
              <input
                type="text"
                id="title"
                name="title"
                className="px-4 py-2 w-full mb-4 text-xl text-[#495057] border border-solid focus:text-[#495057] focus:border-[#80bdff] focus:outline-0 focus:shadow-form border-[#ced4da] rounded-md transition-shadow duration-150 ease-in-out leading-6"
                onChange={handleInputChange}
              />
              <p className="mb-1">
                By clicking ‘Save and Agree’, you understand that users will be directed outside of Videospace for this
                poll
              </p>
            </div>
          </div>
        </div>
        <div className="flex text-[13px] py-6 px-7 bg-white rounded-b-lg border-x">
          <button
            className="py-3 px-6 text-black border border-tabBorder ml-auto rounded-[10px] hover:bg-gray-100"
            onClick={hideModal}
          >
            Cancel
          </button>
          <button className={`py-3 px-6 ml-2 rounded-[10px] bg-red-main text-white`} type="submit">
            Save and Agree
          </button>
        </div>
      </form>
    </div>
  );
}
